export const show = (e, props, model, id) => {
  const { history } = props;
  if (!e.target.closest(".ignore")) {
    history.push(`/${model}/${id}`);
  }
};
